import { useSelector } from 'react-redux';

import { AggregatedScores } from '../../components/AggregatedScores';
import { getObjectInfo } from '../../selectors/objectInfo';
import * as styles from './AggregatedScoresContainer.css';

export const AggregatedScoresContainer = () => {
  const objectInfo = useSelector(getObjectInfo);

  if (!objectInfo.sections.length) {
    return null;
  }

  return (
    <section className={styles['root']} data-testid="AggregatedScoresContainer">
      <AggregatedScores sections={objectInfo.sections} />
    </section>
  );
};
